import ReactMarkdown from "react-markdown";
import { useEffect, useRef } from "react";
import botIcon from "../assets/png/red_chat.png";
import Loader from "./Loader";
import '../styles/ChatBot.scss'
import { formatMessageTime } from "../utils/DateFormater";
import { LiaHandPointDown } from "react-icons/lia";

export default function ChatBot({
    messages,
    inputValue,
    onInputChange,
    onSend,
    onMessageClick,
    loading,
    disabled,
    selectedId,
    disabledText,
    blankText,
    chatBotHintsStatus,
    // chatBotHintsText,
    hintsList,
    hintsItemPress
}) {
    const scrollRef = useRef(null);

    // const [chatBotHintsStatus, setChatBotHintsStatus] = useState(true);
    // const [chatBotHintsText, setChatBotHintsText] = useState(true);
    // Auto-scroll to bottom
    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [messages, loading]);

    // const [hintsList, setHintsList] = useState([
    //     "What is KB Accelerator?",
    //     "What is Code Linage?",
    //     "What is PMO Portal?"
    // ]);

    return (
        <div className="lineagebotPanel">
            <div className="chatbotBox">
                <div className={`chatbotMain ${disabled ? "disabledChat" : ""}`}>
                    <div className="chatbotList" id="scrollID" ref={scrollRef}>
                        <div className="chatbotListInner" id="listId">
                            {disabled && disabledText && (
                                <div className="disabledChatMessage">
                                    {disabledText}
                                </div>

                            )}
                            {/* {(messages && messages.length === 0) && selectedId &&
                                <div className='traceText'>
                                    <i className='LeftHandIcon'></i>
                                    You have not asked a question <br /> yet in the bottom chat input.
                                </div>
                            } */}
                            {!disabled && messages && messages.length === 0 && !loading &&
                                // <div className="disabledChatMessage">
                                //     <p>{blankText}</p>
                                // </div>
                                <div className='disabledChatMessage'>
                                    {/* <i className='LeftHandIcon'></i> */}
                                    <LiaHandPointDown  className="bottomHand"/>
                                    Please enter your question <br /> below to start.
                                </div>
                            }
                            {!disabled &&
                                messages.map((message, index) => {
                                    if (message.type === "user") {
                                        return (
                                            <div
                                                className="cahtbotIterations userResponse"
                                                key={index}
                                            >
                                                <div className="cahtbotInner flex-wrap">
                                                    <div className="chatBotBubble">
                                                        <div className="chatBotContent">
                                                            <ReactMarkdown>{message.content}</ReactMarkdown>
                                                        </div>
                                                    </div>
                                                    <small className="dateSmall">
                                                        {formatMessageTime(message.timestamp)}
                                                    </small>
                                                </div>
                                            </div>
                                        );
                                    }
                                    // 🔥 YOUR EXACT BOT BLOCK (unchanged)
                                    return (
                                        <div
                                            className={
                                                message.id === selectedId
                                                    ? "selectedBubble cahtbotIterations botResponse"
                                                    : "cahtbotIterations botResponse"
                                            }
                                            onClick={() => onMessageClick(message)}
                                            id={message.id}
                                            key={index}
                                        >
                                            <div className="cahtbotInner w-100">
                                                <div className="chatBotImg">
                                                    <img src={botIcon} alt="icon" />
                                                </div>

                                                <div className="chatBotBubble">
                                                    <div className="chatBotContent">
                                                        <ReactMarkdown>{message.content}</ReactMarkdown>
                                                    </div>
                                                </div>

                                                <small className="dateSmall">
                                                    {formatMessageTime(message.timestamp)}
                                                </small>
                                            </div>
                                        </div>
                                    );
                                })
                            }

                            {loading && <Loader show={loading} />}
                        </div>
                    </div>
                    {/* HINTS PANEL */}
                    {chatBotHintsStatus && (
                        <div className="hitnsPanel flex-column">
                            {messages.length === 0 && (
                                <div className="d-flex flex-column align-items-center">
                                    <div className="hintsTitle">Get insight from the project repository!</div>
                                    <div className="hintsSubTitle">Ask anything or try the examples below.</div>
                                </div>
                            )}
                            <div className="d-flex justify-content-center hinstBoxSection">
                                {hintsList.map((item, index) => (
                                    <div
                                        className="hintItem" key={index}
                                        onClick={() => hintsItemPress(item)}
                                    >
                                        {item}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <div className="cahtBotTypeingPanel">
                        <div className="typeingField">
                            <input
                                className="typeingInput"
                                placeholder="Type your question here..."
                                value={inputValue}
                                onChange={(e) => onInputChange(e.target.value)}
                                onKeyDown={(e) => e.key === "Enter" && onSend()}
                                disabled={disabled}
                            />
                        </div>

                        <div className="typeingActions">
                            <span
                                className={`chatbotSend ${disabled ? "disabled" : ""}`}
                                onClick={!disabled ? onSend : undefined}
                            >
                                <span className="sendIcon"></span>
                            </span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}


